import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
let StringService = /*#__PURE__*/(() => {
  class StringService {
    /**
     * Converts a string to a camel case format
     * @param sentenceCase The string to convert to camel case
     * @returns The string in camel case format
     * @example toCamelCase('This is a sentence') => 'thisIsASentence'
     */
    toCamelCase(sentenceCase) {
      return sentenceCase.toLocaleLowerCase().replace(/(?:^.|[A-Z]|\b.)/g, (letter, index) => {
        return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
      }).replace(/\s+/g, '');
    }
    /**
     * Converts any whole string (no spaces) to kebab-case-string
     * @param camelCase The string to convert to kebab case
     * @returns The string in kebab case format
     * @example toKebabCase('thisIsASentence') => 'this-is-a-sentence'
     */
    toKebabCase(camelCase) {
      if (!camelCase) {
        return '';
      }
      return camelCase.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
    }
  }
  StringService.ɵfac = function StringService_Factory(t) {
    return new (t || StringService)();
  };
  StringService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: StringService,
    factory: StringService.ɵfac,
    providedIn: 'root'
  });
  return StringService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generates a random hex output for a given length
 * @example const randomString = hexGenerate(15); // '52fa7c9871e38c2'
 */
function hexGenerate(length) {
  return [...Array(length)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
}

/**
 * Generated bundle index. Do not edit.
 */

export { StringService, hexGenerate };
